import { useOffers } from 'components/Signup/hooks/useOffers';
import { useSignupData } from 'components/Signup/hooks/useSignupData';
import { useNumberFormat } from 'hooks/useNumberFormat';
import styles from './TradingHistoryTitle.module.css';

export const TradingHistoryTitle = () => {
  const { formatCurrency } = useNumberFormat();
  const {
    autoBankStatements,
    documentRequirements,
    isLoadingOffers,
    isRefetchingOffers,
  } = useOffers({ getOffersEnabled: true });
  const { applicationData } = useSignupData();

  const isLoading =
    isLoadingOffers || (isRefetchingOffers && !documentRequirements);

  return (
    <div className={styles.headingContainer}>
      <h1 className={styles.heading}>
        You're requesting a <b>{formatCurrency(applicationData.amount)}</b>{' '}
        credit limit for a{' '}
        <b>{applicationData.loanDuration?.replace(/-/g, ' ')} </b>
        term
      </h1>
      <p className={styles.mainSubHeading}>
        {isLoading && 'Loading your required documents...'}
        {!isLoading &&
          autoBankStatements &&
          'We are not able to provide an instant offer for this particular application. However, we will be able to review this application within 24 hours following a submission of bank statements.'}
      </p>
    </div>
  );
};
